'use client';

import tinycolor from "../../../external/tinycolor2/esm/tinycolor.js";
function getContrast(color1, color2) {
  return tinycolor.readability(color1, color2);
}
export {
  getContrast
};
